import React, { useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import NDAStep from './components/NDAStep';
import ComplianceStep from './components/ComplianceStep';
import DataRoom from './components/DataRoom';
import CompletionStep from './components/CompletionStep';

interface User {
  id: string;
  email: string;
  name: string;
  role: string;
  company: string;
  companyAddress?: string;
  streetNumber?: string;
  zipCode?: string;
  city?: string;
  country?: string;
  twoFactorEnabled: boolean;
  firstName?: string;
  lastName?: string;
  title?: string;
  gender?: string;
  phone?: string;
}

const App: React.FC = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [ndaSigned, setNdaSigned] = useState(false);
  const [complianceVerified, setComplianceVerified] = useState(false);
  const [dataRoomAccessed, setDataRoomAccessed] = useState(false);
  const [user, setUser] = useState<User | null>(null);

  const handleLoginSuccess = (userData: User) => {
    setUser(userData);
    setIsAuthenticated(true);
  };

  return (
    <Routes>
      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route
        path="/login"
        element={
          <Login
            onLoginSuccess={handleLoginSuccess}
            isAuthenticated={isAuthenticated}
          />
        }
      />
      <Route
        path="/nda"
        element={
          isAuthenticated ? (
            <NDAStep 
              onNDASigned={() => setNdaSigned(true)} 
              ndaSigned={ndaSigned}
              userCompany={user?.company || '[Your Company]'}
              userCompanyAddress={user?.companyAddress}
              userStreetNumber={user?.streetNumber}
              userZipCode={user?.zipCode}
              userCity={user?.city}
              userCountry={user?.country}
            />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/compliance"
        element={
          isAuthenticated && ndaSigned ? (
            <ComplianceStep
              onComplianceVerified={() => setComplianceVerified(true)}
              complianceVerified={complianceVerified}
            />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/data-room"
        element={
          isAuthenticated && ndaSigned && complianceVerified ? (
            <DataRoom
              onDataRoomAccessed={() => setDataRoomAccessed(true)}
              dataRoomAccessed={dataRoomAccessed}
            />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/completion"
        element={
          isAuthenticated && ndaSigned && complianceVerified && dataRoomAccessed ? (
            <CompletionStep />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
    </Routes>
  );
};

export default App; 